/** Green whiteboard / chalkboard plane with faint maths scribbles. */
export function HomeBoardBackground() {
  return (
    <div
      aria-hidden
      className="home-board-bg pointer-events-none absolute inset-0 overflow-hidden"
    >
      <div className="home-board-wash absolute inset-0" />
      <svg
        className="home-board-scribbles absolute inset-0 h-full w-full"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 1600"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <pattern
            id="home-board-grid"
            width="40"
            height="40"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M40 0H0V40"
              fill="none"
              stroke="rgba(220,245,225,0.07)"
              strokeWidth="1"
            />
          </pattern>
        </defs>
        <rect width="1000" height="1600" fill="url(#home-board-grid)" />

        <g
          fill="rgba(236,252,240,0.2)"
          stroke="none"
          fontFamily="Georgia, 'Times New Roman', serif"
        >
          <text x="40" y="90" fontSize="26" transform="rotate(-8 40 90)">
            y = mx + c
          </text>
          <text x="580" y="70" fontSize="22" transform="rotate(5 580 70)">
            a² + b² = c²
          </text>
          <text x="320" y="120" fontSize="18" transform="rotate(-2 320 120)">
            2x − 5 = 11
          </text>
          <text x="820" y="130" fontSize="17" transform="rotate(8 820 130)">
            x ∈ ℝ
          </text>

          <text x="100" y="220" fontSize="24" transform="rotate(4 100 220)">
            ∫ x² dx
          </text>
          <text x="450" y="200" fontSize="19" transform="rotate(-6 450 200)">
            Σ n = 1→∞
          </text>
          <text x="700" y="250" fontSize="21" transform="rotate(-4 700 250)">
            3x + 7 = 19
          </text>
          <text x="50" y="280" fontSize="16" transform="rotate(7 50 280)">
            1/2 + 1/3 = 5/6
          </text>

          <text x="200" y="360" fontSize="20" transform="rotate(-5 200 360)">
            e^(iπ) + 1 = 0
          </text>
          <text x="620" y="350" fontSize="18" transform="rotate(3 620 350)">
            P(A∪B)
          </text>
          <text x="80" y="420" fontSize="22" transform="rotate(-3 80 420)">
            sin²θ + cos²θ = 1
          </text>
          <text x="520" y="430" fontSize="17" transform="rotate(9 520 430)">
            tan θ = opp/adj
          </text>
          <text x="780" y="400" fontSize="19" transform="rotate(-7 780 400)">
            n(n+1)/2
          </text>

          <text x="140" y="520" fontSize="18" transform="rotate(2 140 520)">
            mean = Σx / n
          </text>
          <text x="480" y="540" fontSize="23" transform="rotate(-4 480 540)">
            Δ = b² − 4ac
          </text>
          <text x="780" y="510" fontSize="16" transform="rotate(6 780 510)">
            |x − μ|
          </text>
          <text x="60" y="600" fontSize="20" transform="rotate(-8 60 600)">
            5 : 3 = 20 : 12
          </text>
          <text x="400" y="620" fontSize="18" transform="rotate(5 400 620)">
            2πr
          </text>
          <text x="680" y="600" fontSize="21" transform="rotate(-2 680 600)">
            π ≈ 3.14159
          </text>

          <text x="90" y="700" fontSize="19" transform="rotate(3 90 700)">
            ax² + bx + c = 0
          </text>
          <text x="500" y="710" fontSize="17" transform="rotate(-9 500 710)">
            gradient = rise/run
          </text>
          <text x="800" y="690" fontSize="18" transform="rotate(4 800 690)">
            V = ⁴⁄₃πr³
          </text>

          <text x="50" y="800" fontSize="22" transform="rotate(-5 50 800)">
            f′(x) = lim h→0
          </text>
          <text x="420" y="820" fontSize="16" transform="rotate(7 420 820)">
            0.75 = 3/4
          </text>
          <text x="700" y="790" fontSize="20" transform="rotate(-3 700 790)">
            √(a² + b²)
          </text>
          <text x="200" y="880" fontSize="18" transform="rotate(2 200 880)">
            180° in a triangle
          </text>
          <text x="560" y="900" fontSize="19" transform="rotate(-6 560 900)">
            ½bh
          </text>
          <text x="820" y="870" fontSize="17" transform="rotate(8 820 870)">
            log₁₀ 100 = 2
          </text>

          <text x="70" y="980" fontSize="21" transform="rotate(-4 70 980)">
            (x − a)(x − b) = 0
          </text>
          <text x="480" y="1000" fontSize="18" transform="rotate(5 480 1000)">
            ∠ABC = 90°
          </text>
          <text x="750" y="970" fontSize="16" transform="rotate(-7 750 970)">
            7 × 8 = 56
          </text>
          <text x="150" y="1080" fontSize="20" transform="rotate(3 150 1080)">
            √2 ≈ 1.414
          </text>
          <text x="500" y="1100" fontSize="17" transform="rotate(-2 500 1100)">
            median & mode
          </text>
          <text x="780" y="1070" fontSize="19" transform="rotate(6 780 1070)">
            y ∝ 1/x
          </text>

          <text x="40" y="1180" fontSize="18" transform="rotate(-6 40 1180)">
            360° about a point
          </text>
          <text x="380" y="1200" fontSize="22" transform="rotate(4 380 1200)">
            SOH CAH TOA
          </text>
          <text x="720" y="1170" fontSize="16" transform="rotate(-5 720 1170)">
            2³ = 8
          </text>
          <text x="100" y="1280" fontSize="19" transform="rotate(2 100 1280)">
            area = πr²
          </text>
          <text x="450" y="1300" fontSize="17" transform="rotate(-8 450 1300)">
            x = (−b ± √Δ)/2a
          </text>
          <text x="780" y="1270" fontSize="20" transform="rotate(3 780 1270)">
            9/12 = 3/4
          </text>

          <text x="60" y="1380" fontSize="18" transform="rotate(-3 60 1380)">
            parallel lines · Z angles
          </text>
          <text x="520" y="1410" fontSize="21" transform="rotate(5 520 1410)">
            φ ≈ 1.618
          </text>
          <text x="300" y="1480" fontSize="16" transform="rotate(-4 300 1480)">
            1, 1, 2, 3, 5, 8…
          </text>
          <text x="700" y="1500" fontSize="18" transform="rotate(7 700 1500)">
            A = lw
          </text>
          <text x="80" y="1550" fontSize="17" transform="rotate(2 80 1550)">
            % change = (new−old)/old
          </text>
        </g>

        <g
          fill="none"
          stroke="rgba(236,252,240,0.18)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="900" cy="180" r="36" />
          <path d="M864 180h72M900 144v72" />
          <path d="M40 340l50 70h-100z" />
          <path d="M480 140l45 60h-90z" />
          <path d="M860 520c35-35 100-30 130 25" />
          <path d="M300 640c50 35 120 25 160-25" />
          <rect x="850" y="740" width="70" height="70" rx="4" />
          <path d="M850 775h70M885 740v70" />
          <path d="M120 920l60 90 60-90z" />
          <path d="M600 860c-20 40 20 80 70 70" />
          <circle cx="900" cy="1020" r="28" />
          <path d="M872 1020h56" />
          <path d="M200 1220c40-50 100-40 130 10s20 90-30 100" />
          <path d="M720 1340l40 55h-80z" />
          <path d="M400 1540c60-20 100 30 80 70" />
          {/* axes doodle */}
          <path d="M880 1280v-80h80" />
          <path d="M880 1240c20-25 45-35 70-40" />
          {/* number line ticks */}
          <path d="M40 740h200M60 732v16M100 732v16M140 732v16M180 732v16M220 732v16" />
          {/* brackets / set doodle */}
          <path d="M920 380c-12-8-12-24 0-32M940 348c12 8 12 24 0 32" />
        </g>

        {/* Fainter second layer for density */}
        <g
          fill="rgba(236,252,240,0.11)"
          stroke="none"
          fontFamily="Georgia, 'Times New Roman', serif"
        >
          <text x="250" y="60" fontSize="14" transform="rotate(12 250 60)">
            ≈
          </text>
          <text x="900" y="300" fontSize="15" transform="rotate(-12 900 300)">
            ≠
          </text>
          <text x="30" y="480" fontSize="14">≤ ≥</text>
          <text x="900" y="620" fontSize="15" transform="rotate(10 900 620)">
            ∞
          </text>
          <text x="30" y="900" fontSize="14" transform="rotate(-10 30 900)">
            ∴ ∵
          </text>
          <text x="900" y="1180" fontSize="14">⊥ ∥</text>
          <text x="250" y="1350" fontSize="15" transform="rotate(8 250 1350)">
            ±
          </text>
          <text x="900" y="1450" fontSize="14" transform="rotate(-6 900 1450)">
            ≅
          </text>
        </g>
      </svg>
      <div className="home-board-vignette absolute inset-0" />
    </div>
  );
}
